const state = {
    // Store filters per site to allow different filters for different sites
    siteFilters: {},
    // Store the current site ID to track which site's filters we're working with
    currentSiteId: null,
    // Store pagination state
    pagination: {
        first: 0
    },
    // Store whether we're using filtered values
    useFilteredValues: false
};

const getters = {
    getSiteFilters: (state) => (siteId) => {
        return state.siteFilters[siteId] || getDefaultFilters();
    },
    getCurrentSiteFilters: (state) => {
        return state.siteFilters[state.currentSiteId] || getDefaultFilters();
    },
    getPagination: (state) => {
        return state.pagination;
    },
    getUseFilteredValues: (state) => {
        return state.useFilteredValues;
    }
};

const mutations = {
    SET_SITE_FILTERS(state, { siteId, filters }) {
        state.siteFilters = {
            ...state.siteFilters,
            [siteId]: filters
        };
    },
    SET_CURRENT_SITE_ID(state, siteId) {
        state.currentSiteId = siteId;
    },
    SET_PAGINATION(state, pagination) {
        state.pagination = { ...state.pagination, ...pagination };
    },
    SET_USE_FILTERED_VALUES(state, value) {
        state.useFilteredValues = value;
    },
    CLEAR_SITE_FILTERS(state, siteId) {
        if (siteId) {
            const newSiteFilters = { ...state.siteFilters };
            delete newSiteFilters[siteId];
            state.siteFilters = newSiteFilters;
        } else {
            state.siteFilters = {};
        }
    },
    CLEAR_ALL_FILTERS(state) {
        state.siteFilters = {};
        state.pagination = { first: 0 };
        state.useFilteredValues = false;
    }
};

const actions = {
    setSiteFilters({ commit }, { siteId, filters }) {
        commit('SET_SITE_FILTERS', { siteId, filters });
        commit('SET_CURRENT_SITE_ID', siteId);
    },
    setPagination({ commit }, pagination) {
        commit('SET_PAGINATION', pagination);
    },
    setUseFilteredValues({ commit }, value) {
        commit('SET_USE_FILTERED_VALUES', value);
    },
    clearSiteFilters({ commit }, siteId) {
        commit('CLEAR_SITE_FILTERS', siteId);
    },
    clearAllFilters({ commit }) {
        commit('CLEAR_ALL_FILTERS');
    }
};

// Helper function to get default filter structure
const getDefaultFilters = () => ({
    asset_id: null,
    name: [],
    category: [],
    asset_type: [],
    location: [],
    area: [],
    make: [],
    model: [],
    install_date: [],
    lifecycle_expiry_date: [],
    last_maintained_date: [],
    maintenance_schedule_start_date: [],
    warranty_expiry_date: [],
    lifecycle_status: [],
    warranty_status: [],
    maintenance_status: [],
    maintenance_current_status: [],
    fault_status: []
});

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}; 